import { GLOBAL_CAMPAIGNS, RECOMMENDATIONS_CAMPAIGNS } from '~/constants/campaigns';
import * as DataDogLogs from '~/lib/datadog/datadog';

/**
 * Pull the analytics metadata from Dynamic Yield choice response
 *
 * @param {Object} choice - The choice object returned by Dynamic Yield
 * @returns {Object} The analytics metadata object
 */
const getMainAnalyticsMetadata = (choice) => {
  // Log error if no choice is provided
  if (!choice || !choice?.variations) {
    DataDogLogs.error(
      '[Allbirds utils] - getMainAnalyticsMetadata - no choice with variations provided',
      { choice },
    );

    return;
  }

  // Log warning if there are more than one variation for the campaign
  if (choice?.variations?.length > 1) {
    DataDogLogs.warn(
      '[Allbirds utils] - getMainAnalyticsMetadata - more than one variation for the campaign',
      { choice, selectorName: choice.name },
    );
  }

  // Log warning if there are no variations for the campaign
  if (choice?.variations?.length === 0) {
    DataDogLogs.warn(
      '[Allbirds utils] - getMainAnalyticsMetadata - no variations for the campaign',
      {
        choice,
        selectorName: choice.name,
      },
    );
  }

  // Pull the analytics metadata from the first variation
  return choice?.variations?.[0]?.analyticsMetadata;
};

/**
 * Get the experiment type for a given selector name
 *
 * @param {string} selectorName - The name of the selector
 * @returns {string} The experiment type
 */
const getExperimentTypeBySelectorName = (selectorName) => {
  const ALL_CAMPAIGNS = [
    ...Object.values(GLOBAL_CAMPAIGNS),
    ...Object.values(RECOMMENDATIONS_CAMPAIGNS),
  ];

  const result = ALL_CAMPAIGNS.find((campaign) => campaign.selectorName === selectorName);

  if (!result || !result?.experimentType) {
    DataDogLogs.warn(
      '[Allbirds utils] - getExperimentTypeBySelectorName - no experiment type found for selector name',
      { selectorName },
    );
  }

  return result?.experimentType;
};

export { getExperimentTypeBySelectorName, getMainAnalyticsMetadata };
